import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import MuiTypography from '@mui/material/Typography';

import { responsiveFontSizes } from './fontSizes';

interface TextProps extends Omit<MuiTypographyProps, 'size'> {
  size?: keyof typeof responsiveFontSizes; // 32, 24, etc.
}

const Text = ({ size, sx, ...rest }: TextProps) => {
  if (size === undefined) {
    return (
      <MuiTypography
        sx={sx}
        {...rest}
      />
    );
  }
  const sxArray = Array.isArray(sx) ? sx : [sx];
  return (
    <MuiTypography
      sx={[{ fontSize: responsiveFontSizes[size] }, ...sxArray]}
      {...rest}
    />
  );
};

export default Text;
